'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadInitialApp = exports.LOAD_INITIAL_APP = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.maybeShowUnpaidAccountAnnouncement = maybeShowUnpaidAccountAnnouncement;
exports.addUserMsaAliasToLocalStorage = addUserMsaAliasToLocalStorage;
exports.initializeReferAFriend = initializeReferAFriend;
exports.initializeUserLocation = initializeUserLocation;
exports.doLoadInitialApp = doLoadInitialApp;
exports.watchLoadInitialApp = watchLoadInitialApp;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _cookie = require('cookie');

var _UnpaidAccountBanner = require('components/Banner/Banners/UnpaidAccountBanner');

var _memberStatus = require('enums/memberStatus');

var _BannerHost = require('features/Banners/BannerHost');

var _Banners = require('features/Banners/Banners.reducer');

var _Banners2 = require('features/Banners/Banners.saga');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

var _localStorage = require('redux/saga/helpers/local-storage');

var _selectors = require('redux/saga/selectors');

var _friendbuy = require('redux/saga/selectors/friendbuy');

var _helpers = require('redux/saga/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(maybeShowUnpaidAccountAnnouncement),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addUserMsaAliasToLocalStorage),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(initializeReferAFriend),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(initializeUserLocation),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doLoadInitialApp),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchLoadInitialApp);

var LOAD_INITIAL_APP = exports.LOAD_INITIAL_APP = 'LOAD_INITIAL_APP';
var loadInitialApp = exports.loadInitialApp = function loadInitialApp() {
  return { type: LOAD_INITIAL_APP };
};

function maybeShowUnpaidAccountAnnouncement(user) {
  return _regenerator2.default.wrap(function maybeShowUnpaidAccountAnnouncement$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(0, _memberStatus.memberStatus)('UNPAID', user.membership.status)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return (0, _effects.call)(_BannerHost.registerBanner, 'UnpaidAccountAnnouncement', _UnpaidAccountBanner.UnpaidAccountBanner);

        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _Banners.addAnnouncement)('unpaid_account', 'UnpaidAccountAnnouncement'));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function addUserMsaAliasToLocalStorage(client) {
  var msa;
  return _regenerator2.default.wrap(function addUserMsaAliasToLocalStorage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_helpers.geodetectMsa, client);

        case 3:
          msa = _context2.sent;

          if (!msa) {
            _context2.next = 7;
            break;
          }

          _context2.next = 7;
          return (0, _effects.call)(_localStorage.writeLocalStorage, 'userMsaAlias', msa.alias);

        case 7:
          _context2.next = 11;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2['catch'](0);

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 9]]);
}

function initializeReferAFriend(client) {
  var referAFriendCode;
  return _regenerator2.default.wrap(function initializeReferAFriend$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_friendbuy.friendbuyCode);

        case 2:
          referAFriendCode = _context3.sent;

          if (!referAFriendCode) {
            _context3.next = 12;
            break;
          }

          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.friendbuy, [client, referAFriendCode]);

        case 7:
          if (__CLIENT__ || __TEST__) {
            document.cookie = (0, _cookie.serialize)(_friendbuy.FBUY_COOKIE_NAME, referAFriendCode);
          }
          _context3.next = 12;
          break;

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3['catch'](4);

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[4, 10]]);
}

function initializeUserLocation() {
  var _ref, lat, lon, expires;

  return _regenerator2.default.wrap(function initializeUserLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_localStorage.readLocalStorage, 'userLocation', {});

        case 3:
          _ref = _context4.sent;
          lat = _ref.lat;
          lon = _ref.lon;
          expires = _ref.expires;

          if (!(expires <= Date.now())) {
            _context4.next = 12;
            break;
          }

          _context4.next = 10;
          return (0, _effects.call)(_localStorage.removeLocalStorage, 'userLocation');

        case 10:
          _context4.next = 15;
          break;

        case 12:
          if (!(lat && lon)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 15;
          return (0, _effects.put)((0, _locale.setUserSelectedLocation)(lat, lon));

        case 15:
          _context4.next = 19;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4['catch'](0);

        case 19:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 17]]);
}

function doLoadInitialApp(client) {
  var userIsLoggedIn, user;
  return _regenerator2.default.wrap(function doLoadInitialApp$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          userIsLoggedIn = _context5.sent;
          _context5.next = 5;
          return (0, _effects.all)([(0, _effects.spawn)(_Banners2.watchBannerSagas), (0, _effects.call)(initializeReferAFriend, client), (0, _effects.call)(initializeUserLocation), (0, _effects.call)(addUserMsaAliasToLocalStorage, client)]);

        case 5:
          if (userIsLoggedIn) {
            _context5.next = 7;
            break;
          }

          return _context5.abrupt('return');

        case 7:
          _context5.next = 9;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 9:
          user = _context5.sent;
          _context5.next = 12;
          return (0, _effects.all)([(0, _effects.call)(maybeShowUnpaidAccountAnnouncement, user), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userUpcomingReservations, [client, user.id]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, user.id]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userCreditBalance, [client, user.id])]);

        case 12:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchLoadInitialApp(client) {
  return _regenerator2.default.wrap(function watchLoadInitialApp$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_INITIAL_APP, doLoadInitialApp, client);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}